import { render, staticRenderFns } from "./CGSZ.vue?vue&type=template&id=243d012e&scoped=true"
import script from "./CGSZ.vue?vue&type=script&lang=js"
export * from "./CGSZ.vue?vue&type=script&lang=js"
import style0 from "./CGSZ.vue?vue&type=style&index=0&id=243d012e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d012e",
  null
  
)

export default component.exports